$('.select').on('click', '.select-head', function () {
  if ($(this).hasClass('open')) {
    $(this).removeClass('open')
    $(this).next().fadeOut()
  } else {
    $('.select-head').removeClass('open')
    $('.select-list').fadeOut()
    $(this).addClass('open')
    $(this).next().fadeIn()
  }
  
  $('.select').find('.select-search').focus()

})

$('.select').on('click', '.select-item', function () {
  
  const inputField = $(this).parents('.select').find('input')
  $('.select-head').removeClass('open placeholder')
  $(this).parent().fadeOut()
  $(this).parent().prev().text($(this).text())

  if (!$(this).data('filter-id')) {
    return; 
  }
  
  inputField.val($(this).data('filter-id')).change()
})

$(document).on('click', (e) => {
  if (!$(e.target).closest('.select').length) {
    $('.select-head').removeClass('open')
    $('.select-list').fadeOut()
  }
})

document.querySelectorAll('.js-filter .select .select-item').forEach((elem) => {
  elem.addEventListener('click', (event) => {
    if (!event.target.dataset.filterId) {
      return;
    }
    
    setTimeout(() => {
      event.target.closest('.js-filter').submit();
    }, 100);
  });
});


$(document).ready(() => {
  const containerSelect = document.querySelector('.js-container-select')

  if (containerSelect) {
    const containerItem = containerSelect.firstElementChild

    if (containerItem) {
      containerSelect.parentNode.replaceChild(containerItem, containerSelect)
    }
  }

  const lastActiveItems = {}

  $('.select-input').change(function () {
    const selectedId = $(this).val()
    const selectId = $(this).data('select-id')

    const form = $(this).closest('form')

    const currentSelectKey = `${selectId}`

    if (lastActiveItems[currentSelectKey]) {
      lastActiveItems[currentSelectKey].addClass('hidden')
    }

    const currentItem = form.find(`.js-conteiner-item[data-container-id="${selectedId}"]`)
    currentItem.removeClass('hidden')

    lastActiveItems[currentSelectKey] = currentItem
  })
})

$('.select-search').on('input', function () {
  const searchText = $(this).val().toLowerCase().trim();
  $(this).closest('.select-list').find('.select-item').each(function () {
    const itemText = $(this).text().toLowerCase().trim();
    const words = itemText.split(/\s+/); 

    const isMatch = words.some(word => word.startsWith(searchText));

    $(this).toggle(isMatch);
  });
});


